import React, { useEffect, useContext, useState } from "react";
import { DefaultTheme, ThemeContext } from "styled-components";

import { Hero, Button } from "../../../../components";

import { Container, Section, Buttons } from "./styles";
import { NavigateButtonsContext, DataUserContext } from "../../../Criare";
import { sendInitial, getStoresByLink } from "../../../../services/data-service/api";
import eventTypes from "../../../../events/event-types.const";
import HistoryPages from "../../../../events";
import can from "../../../../utils/can";
import { useLocation } from "react-router-dom";

const Question01: React.FC = () => {
  const { next } = useContext(NavigateButtonsContext);
  const { setHomeIgnored, token } = useContext(DataUserContext);
  const _theme = useContext(ThemeContext);
  const [theme, setTheme] = useState({} as DefaultTheme);
  const [answer, setAnswer] = useState<boolean>();

  const location = useLocation();

  useEffect(() => {
    if (_theme.steps) {
      setTheme(_theme);
    }
  }, [_theme]);

  useEffect(() => {
    if (answer === true) {
      sendInitial("sim", token);
      next(3);

      // window.dataLayer = window.dataLayer || [];
      // function gtag(){dataLayer.push(arguments);}
      // gtag('js', new Date());
      // gtag('config', 'G-RBWTVXWJKH');
  
      
    } else if (answer === false) {
      setHomeIgnored(true);
      sendInitial("nao", token);
      next(4);
    }
  }, [answer, next, token, setHomeIgnored]);

  useEffect(() => {
    HistoryPages.emit(eventTypes.SAVE, 2);
    setHomeIgnored(false);
  }, []);

  return (
    <>
      {theme.status === "success" && (
        <Container>
          <Hero
            criare
            image={can(
              theme,
              "theme.steps.etapa_inicial.propriedades.imagens.etapa_inicial_imagemBanner.url"
            )}
            title={can(
              theme,
              "theme.steps.etapa_inicial.propriedades.banner.subtituloBanner"
            )}
            subscript={can(
              theme,
              "theme.steps.etapa_inicial.propriedades.banner.tituloBanner"
            )}
            isHome
          />

          <Section>
            <p>
              {can(
                theme,
                "theme.steps.etapa_inicial.propriedades.conteudo.titulo"
              )}
            </p>

            <p>
              {can(
                theme,
                "theme.steps.etapa_inicial.propriedades.conteudo.subtitulo"
              )}
            </p>

            <Buttons>
              <Button
                criare
                icon={
                  <img
                    src={can(
                      theme,
                      "theme.steps.etapa_inicial.propriedades.imagens.etapa_inicial_iconeNao.url"
                    )}
                    alt=""
                  />
                }
                title={can(
                  theme,
                  "theme.steps.etapa_inicial.propriedades.conteudo.texto_nao"
                )}
                onClick={() => {
                  setAnswer(false);
                }}
              />
              <Button
                criare
                icon={
                  <img
                    src={can(
                      theme,
                      "theme.steps.etapa_inicial.propriedades.imagens.etapa_inicial_iconeSim.url"
                    )}
                    alt=""
                  />
                }
                title={can(
                  theme,
                  "theme.steps.etapa_inicial.propriedades.conteudo.texto_sim"
                )}
                onClick={() => {
                  setAnswer(true);
                }}
              />
            </Buttons>
          </Section>
        </Container>
      )}
    </>
  );
};

export default Question01;
